import { Device } from '@chargify/device-provider';

/**
 * Updates position of toast notifications container
 * @param {string} htmlElement - HTML element reference
 * @param {Device} device - type of user device
 */
export const setNotificationsPosition = (
  htmlElement: HTMLDivElement,
  device: Device
) => {
  if (device === 'mobile') {
    htmlElement.style.left = '0px';
    htmlElement.style.top = '0px';
    htmlElement.style.bottom = 'initial';
    htmlElement.style.right = 'initial';
    htmlElement.style.width = '100%';
  } else {
    htmlElement.style.bottom = '0px';
    htmlElement.style.right = '0px';
    htmlElement.style.left = 'initial';
    htmlElement.style.top = 'initial';
    htmlElement.style.width = 'initial';
  }
};
